export function getLengthWithChineseCount(str) {
  if (!str) {
    return 0;
  }
  let length = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charAt(i);
    if (/[\u4e00-\u9fff]/.test(char)) {
      length += 2;
    } else {
      length++;
    }
  }
  return length;
}

// 计算除以最大公约数以后的整数
export function findRatio(num1, num2) {
  const _n1 = Number(num1);
  const _n2 = Number(num2);
  if (!_n1 || !_n2) {
    return [1, 1];
  }
  let gcd = findGCD(_n1, _n2);
  return [_n1 / gcd, _n2 / gcd];
}

// 计算最大公约数
export function findGCD(a, b) {
  while (b !== 0) {
    let temp = b;
    b = a % b;
    a = temp;
  }
  return a || 1;
}
// 计算页面字符的宽度
export const getLetterWidth = (letter, fontSize) => {
  const dom = document.createElement('span');
  dom.style.display = 'inline-block';
  dom.style.visibility = 'hidden';
  dom.style.fontSize = fontSize + 'px';
  dom.textContent = letter;
  document.body.appendChild(dom);
  const width = dom.getBoundingClientRect().width;
  dom.remove();
  return Number(width.toFixed(2));
};
// 将0-1之间的数转成0.3-1
export const transfer0_1To03_1 = (num) => {
  if (num < 0) {
    return 0;
  }
  if (num >= 0 && num <= 1) {
    return num * 0.7 + 0.3;
  }
  return 1;
};
// 将0-1之间的数转成3-
export const transfer0_1To3_5 = (num) => {
  if (num < 0) {
    return 3;
  }
  if (num >= 0 && num <= 1) {
    return num * 2 + 3;
  }
  return 5;
};
// 将0-1之间的数转成0.6-1
export const transfer0_1To06_1 = (num) => {
  if (num < 0) {
    return 0.6;
  }
  if (num >= 0 && num <= 1) {
    return num * 0.4 + 0.6;
  }
  return 1;
};

// 获取图片的oss存储路径
export function getImageOssPath(url) {
  if (!url) return '';
  if (!url.startsWith('http')) return url;

  try {
    return new URL(url).pathname.replace(/^\//, '');
  } catch (e) {
    console.error('getImageOssPath error:', e);
    return '';
  }
}
